import { render, staticRenderFns } from "./ScoreSetGalleryDates.vue?vue&type=template&id=cb1653b6"
import script from "./ScoreSetGalleryDates.vue?vue&type=script&lang=js"
export * from "./ScoreSetGalleryDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports